import { css } from "styled-components";
export var AccessibleOutlineCSS = css([
    "&:focus-visible{outline:auto;outline:2px solid -webkit-focus-ring-color;outline-offset:2px;z-index:1;}"
]);
